<form [formGroup]="profileForm" class="enhance-profile-form">
  <div class="enhance-profile-container">
    <div class="enhance-profile-title">Enhance Details</div>
    <rkt-form class="enhance-profile-options" [form]="profileForm" [fields]="profileFields()" [model]="formModel"></rkt-form>

    @if (entityType() === 'CUSTOMER') {
      <div class="enhance-beneficiary-documents-title">ID Documents</div>
      <rkt-form class="enhance-profile-options" [form]="profileForm" [fields]="documentFields()" [model]="formModel"></rkt-form>

      @if (isOtherSelected()) {
        <div class="other-documents" [formGroup]="otherDocumentsForm">
          <div class="enhance-beneficiary-documents-title">Other Documents</div>
          <div class="other-documents-list" formArrayName="otherDocuments">
            @for (document of otherDocuments.controls; track document; let i = $index) {
              <div class="other-document-item" [formGroupName]="i">
                <div class="other-document-fields">
                  <label class="other-document-label">
                    Document Name*
                    <input type="text" class="other-document-name" formControlName="name" maxlength="255" placeholder="Document Name" />
                  </label>
                  <label class="other-document-label">
                    Description
                    <input
                      type="text"
                      class="other-document-description"
                      formControlName="description"
                      maxlength="1024"
                      placeholder="Description (optional)"
                    />
                  </label>
                </div>
                @if (otherDocuments.length > 1) {
                  <button
                    type="button"
                    rktButton
                    btnType="tertiary"
                    class="other-document-remove"
                    title="Remove"
                    (click)="removeOtherDocument(i)"
                  >
                    Remove
                  </button>
                }
                @if (document.controls.name.touched && document.controls.name.invalid) {
                  <div class="other-document-error">Please enter a valid document name.</div>
                }
              </div>
            }
            @if (otherDocuments.errors?.['duplicateName']) {
              <div class="other-document-error">Document names must be unique.</div>
            }
          </div>
          <button
            type="button"
            rktButton
            btnType="tertiary"
            class="other-document-add"
            title="Add another document"
            (click)="addOtherDocument()"
          >
            Add another document
          </button>
        </div>
      }
    }
  </div>

  <div class="linx-request-buttons">
    <button rktButton btnType="tertiary" class="linx-request-btn btn-clear" title="Clear" (click)="onClearBtnClick()">Clear</button>

    <button
      rktButton
      title="Continue"
      [disabled]="profileForm.invalid || (isOtherSelected() && otherDocumentsForm.invalid)"
      (click)="onClickContinue()"
    >
      Continue
    </button>
  </div>
</form>
